import { gql, useLazyQuery } from "@apollo/client";
export const GET_TABLE_LIST = gql`
  query getCdlTableList($catalogName: String!, $schemaName: String!) {
    getCdlTableList(
      input: { catalogName: $catalogName, schemaName: $schemaName }
    ) {
      tableId
      columns {
        name
        typeText
      }
      name
      fullName
      updatedAt
      updatedBy
      createdAt
      createdBy
    }
  }
`;

export function useGetCdlTableList() {
  const [
    getCdlTableList,
    { data: tableList, loading: isLoadingTableList, error: errorTableList }
  ] = useLazyQuery(GET_TABLE_LIST);
  return {
    getCdlTableList,
    tableList,
    isLoadingTableList,
    errorTableList
  };
}
